module.exports = __webpack_public_path__ + "img/m.f8352640.jpg";